<template>
  <div id = "choiceWhitebar">

     <div class = "myCommodityWrap">
      <el-row :gutter="25">
        <el-col class = "goodsItem" :span="4" v-for="(item, index) in myCommodityList" :key="index"  >
          <el-card :body-style="{ padding: '20px' }">
            <img :src="renderImg(item.image)" class="image">
            <div style="padding: 14px;">
              <span>品种：{{item.breed}}</span>
              <div class="bottom clearfix checkItem">
                <time class="time">重量：{{item.weight}}{{item.unit}}</time>
                <el-checkbox style = "{width:50px}" v-model="item.checked"></el-checkbox>
                <!-- <el-button type="text" class="button">购买</el-button> -->
              </div>
            </div>
          </el-card>
        </el-col>
      </el-row>
     </div>
    <el-pagination
      background
      @current-change = "currentChange"
      @size-change = "sizeChange"
      layout="sizes, prev, pager, next, jumper, ->, total, slot	"
      :total="totalCount"
    >
    </el-pagination>
    <div class = "operationBtnWrap">
       <el-row>
          <el-button @click = "sureInStorage"  type="primary">确认入库</el-button>
        </el-row>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from "vuex";
import {queryMyWhiteBarList,baseUrl,addStockUrl} from '@/api/api'
  export default {
    data () {
      return {
        count: 100,
        loading: false,
        myCommodityList:[],
        totalCount:0,
        pageSize:10,
        checkbox:[],
        checked:false,
        form:{

        }
      }
    },
    computed: {
      ...mapState(["userInfo"]),
    },
    created(){
      this.initWhitebarData(0,this.pageSize)
    },
    watch:{
      $route(to,from){
        console.log(to,form)
      }
    },
    methods: {
      sureInStorage() {
        let that = this;
        let url = addStockUrl;
        let {access_token, storeId,kind} = this.userInfo;
        let gid = this.$route.query.gid
        let sids = []
        this.myCommodityList.map((item,index)=> {
          if(item.checked){
            sids.push(item.id)
          }
        })
        console.log(gid,sids)
        if(sids&&sids.length<=0){
         this.$message('白条信息无效,请检查是否选择白条');
          return
        }
        let data = {
          access_token,
          storeId,
          gid,
          sids:sids.toString()
        };

        let param = new URLSearchParams();
        for (var k in data) {param.append(k, data[k])}
        this.$axios({
          method: "post",
          data: param,
          url
        })
        .then(res => {
          console.log(res)
          if (res.data.resultCode == 1) {
            this.$router.go(-1)
          }else{
            this.$message(res.data.resultMsg);
          }
        })
        .catch(err => {
          this.$alert(JSON.stringify(err))
        });
      },
      checkItem() {
        console.log(this.myCommodityList)
      },
      checkBox() {
        console.log(this.checkbox)
      },
      sizeChange(size){
         this.pageSize = size
         this.initWhitebarData(0,this.pageSize)
      },
      currentChange(page){
        let pageSize = Number(page) -1
        this.initWhitebarData(pageSize,this.pageSize)
      },
      renderImg(url){
          if(!url){
            return ''
          }
          if (url.startsWith('http') || url.startsWith('file') || url.startsWith('content')) {
            return url
          }
          return  `${baseUrl}/${url}`
      },
      createCommodity() {
        this.$router.push({
          name:'addWhitebar'
        })
      },
      load () {
        this.loading = true
        setTimeout(() => {
          this.count += 2
          this.loading = false
        }, 2000)
      },
      initWhitebarData(pageIndex,pageSize) {
        let that = this;
        let url = queryMyWhiteBarList;
        let {access_token, storeId,kind} = this.userInfo;
        let data = {
          access_token,
          storeId,
          grade:this.$route.query.grade?this.$route.query.grade:1,
          breed:this.$route.query.breed?this.$route.query.breed:'良种猪',
          pageIndex,
          pageSize
        };
        let param = new URLSearchParams();
        for (var k in data) {param.append(k, data[k])}
        this.$axios({
          method: "post",
          data: param,
          url
        })
        .then(res => {
          console.log(res)
          if (res.data.resultCode == 1) {
            const {data,count} = res.data;

            this.myCommodityList = data.map((item,index) => {
              item.checked = false;
              return item
            })

            this.totalCount = count
          }else{
            this.$alert(JSON.stringify(res.data.resultMsg))
          }
        })
        .catch(err => {
           this.$alert(JSON.stringify(err))
        });
      },
    }
  }
</script>
<style scoped lang="less">
  .operationBtnWrap {
    // position:absolute;
    // bottom:100px;
    margin:0 auto;
    width:100px;
  }
  .image {
    width:100%;
    height:373px;
  }
  .goodsItem {
    height:500px;
  }
  .muCommodityWrap {
    overflow:scroll
  }
  .checkItem {
    display:flex;
    flex-direction:row;
    justify-content:space-between;
  }
  .checkBox {
    width:50px;
    height:50px;
  }
</style>



// WEBPACK FOOTER //
// src/components/SellCenter/ChoiceWhitebar.vue